import theme from "@/theme";

export const styles = {
  root: {
    position: "relative",
    backgroundColor: theme.palette.custom.mainWhite,
    boxSizing: "border-box",
    padding: 0,
    margin: 0,
    display: "flex",
    height: "100%",
    zIndex: 3000,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    padding: 0,
    height: "100%",
    minHeight: "0px !important",
    backgroundColor: theme.palette.custom.mainWhite,
  },
  leftBlock: {
    maxWidth: "640px",
    width: "100%",
    height: "48px",
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.custom.mainWhite,
  },

  postFieldWrapper: (focused: boolean) => ({
    margin: "8px 24px 4px 24px",
    width: "100%",
    minWidth: "250px",
    height: focused ? "50px" : "42px",
    borderRadius: "29px",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "relative",
    backgroundColor: theme.palette.custom.blueGray100,
    transition: "all 0.2s ease",
    border: focused ? `1px solid ${theme.palette.primary.main}` : "none",
  }),

  inputField: {
    maxWidth: "592px",
    width: "565px",
    flex: 1,
    fontSize: "1rem",
    paddingLeft: "12px",
    "& input": {
      fontSize: "1rem",
      width: "100%",
    },
  },

  searchField: (focused: boolean) => ({
    height: "42px",
    borderRadius: "33px",
    backgroundColor: focused ? "#FFFFFF" : theme.palette.custom.blueGray100,
    transition: "all 0.2s ease",
    border: focused ? `1px solid ${theme.palette.custom.mainBlue}` : "none",
    "& .MuiOutlinedInput-root": {
      height: "100%",
      padding: "0 10px",
      borderRadius: "12px",
      "& fieldset": {
        border: "none",
      },
      "&:hover fieldset": {
        border: "none",
      },
      "&.Mui-focused fieldset": {
        border: "none",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: 0,
      fontWeight: 500,
      fontSize: "14px",
      caretColor: theme.palette.custom.mainBlue,
    },
  }),

  searchFieldInput: {
    fontSize: "14px",
    width: "300px",
    height: "42px",
    flex: 1,
    paddingLeft: "12px",
  },

  notificationButton: {
    padding: 0,
    color: "text.secondary",
  },

  wrapper: {
    maxWidth: "1200px",
    width: "100%",
    height: "100%",
    display: "grid",
    gridTemplateColumns: "1fr auto",

    alignItems: "center",

    margin: "0 auto",
    background: "#fff",
    "@media (max-width: 450px)": {
      gridTemplateColumns: "1fr",
      gridTemplateRows: "48px 48px",
    },
  },

  postWrapper: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flex: "0 0 auto",
    margin: "auto auto auto 20px",
  },

  backButton: {
    p: 0,
    width: 36,
    height: 36,
    opacity: 1,
  },

  backIcon: {
    width: 36,
    height: 36,
  },

  postTitle: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "100%",
    letterSpacing: "0.02em",
    color: "#383C40",
  },
};
